import { render, staticRenderFns } from "./languages-tab.vue?vue&type=template&id=a22d34e0"
import script from "./languages-tab.vue?vue&type=script&lang=js"
export * from "./languages-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports